import React from "react";

import { getStoryLevelDot, STORY_SOURCES } from "./storyLibrary";

const PROCESSING_LABELS = { error: "Couldn't create", processing: "Creating…", queued: "Creating…" };

export default function StoryRow({ isLocked, item, onOpen }) {
  const source = STORY_SOURCES.find((option) => option.id === item.source);

  return (
    <button className="story-row" data-testid={`story-row-${item.key}`} type="button" onClick={() => onOpen(item)}>
      <span aria-hidden="true" className="story-row-emoji">{item.emoji}</span>
      <span className="story-row-text">
        <span className="story-row-title">{item.title}</span>
        <span className="story-row-details" data-testid={`story-row-details-${item.key}`}>
          {item.status === "complete" && (
            <span className="story-row-meta story-row-complete"><span className="fa fa-check" /> Complete</span>
          )}
          {!!source && <span className="story-row-meta"><span className={`fa fa-${source.rowIcon}`} /> {source.rowLabel}</span>}
          {!!item.level && <span className="story-row-meta"><span className={`story-level-dot ${getStoryLevelDot(item.level)}`} /> {item.level}</span>}
          {isLocked && (
            <span className="story-row-meta" data-testid={`story-row-pro-${item.key}`}><span className="fa fa-lock" /> <span className="joystix">Pro!</span></span>
          )}
          {item.isReady === false ? (
            <span className="story-row-meta"><span className="fa fa-hourglass-half" /> {PROCESSING_LABELS[item.processingStatus]}</span>
          ) : (
            <span className="story-row-meta"><span className="fa fa-clock-o" /> {item.minutes} min</span>
          )}
        </span>
      </span>
      <span aria-hidden="true" className="fa fa-chevron-right story-row-chevron" />
    </button>
  );
}
